module.exports = __webpack_public_path__ + "img/ygzc.d790d3ae.jpg";